import Ticket, { TicketSearchCriteria } from 'src/interfaces/api/Ticket';
import { useEffect, useState } from 'react';
import useTicket from 'src/hooks/api/useTicket';

export default (
  criteria: TicketSearchCriteria,
  limit: number,
  page: number,
  orderBy?: string,
  order?: 'asc' | 'desc'
) => {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [total, setTotal] = useState(0);
  const { search } = useTicket();

  useEffect(() => {
    setLoading(true);
    search(criteria, page + 1, limit, orderBy, order)
      .then((collection) => {
        setTickets(collection.items);
        setTotal(collection.total);

        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, [criteria, limit, page, order, orderBy]);

  return { error, loading, total, tickets };
};
